// Are we rendering on the server or are we in the browser?
export function isBrowser() {
    return typeof document !== 'undefined';
}
export function isServiceWorker() {
    return (!isBrowser() &&
        typeof navigator !== 'undefined' &&
        cachesObjectExistsAndIsCacheStorage());
}
function cachesObjectExistsAndIsCacheStorage() {
    // https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage
    return (typeof caches !== 'undefined' &&
        typeof caches.delete === 'function' &&
        typeof caches.has === 'function' &&
        typeof caches.keys === 'function' &&
        typeof caches.match === 'function' &&
        typeof caches.open === 'function');
}
export function isTouch() {
    return (isBrowser() &&
        ('ontouchstart' in window ||
            (typeof navigator !== 'undefined' &&
                (navigator.maxTouchPoints > 0))));
}
let isCurrentScrollBar;
export function isScrollBar() {
    if (isCurrentScrollBar !== undefined)
        return isCurrentScrollBar;
    return (isCurrentScrollBar =
        isBrowser() &&
            typeof window.innerWidth === 'number' &&
            typeof document.body !== 'undefined' &&
            window.innerWidth > document.body.offsetWidth);
}
export function iOSVersion() {
    if (!isIOS()) {
        throw new Error('Cannot get iOS version on a non-iOS device');
    }
    if (typeof navigator === 'undefined')
        return 0;
    const match = navigator.userAgent.match(/\sOS ([0-9]+_[0-9]+)/);
    if (!match) {
        return 0; // Unknown version
    }
    return parseFloat(match[1].replace('_', '.'));
}
export function isIOS() {
    return (isBrowser() &&
        typeof navigator !== 'undefined' &&
        /iPad|iPhone|iPod/.test(navigator.userAgent));
}
export function isLandscape() {
    return isBrowser() && window.screen.width > window.screen.height;
}
export function isPortrait() {
    return isBrowser() && !isLandscape();
}
export function isIE() {
    return (isBrowser() &&
        typeof navigator !== 'undefined' &&
        /MSIE|Trident/.test(navigator.userAgent));
}
export function isEdge() {
    return (isBrowser() &&
        typeof navigator !== 'undefined' &&
        /Edge/.test(navigator.userAgent));
}
export function isFF() {
    return (isBrowser() &&
        typeof navigator !== 'undefined' &&
        /Firefox/.test(navigator.userAgent));
}
export function isSF() {
    return (isBrowser() &&
        typeof navigator !== 'undefined' &&
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent));
}
export function isAndroid() {
    return (isBrowser() &&
        typeof navigator !== 'undefined' &&
        /android/i.test(navigator.userAgent));
}
export function externalSvgUseSupported() {
    return isBrowser() && !isIE() && !/Edge\/12/.test(navigator.userAgent);
}
function currentStyleProperty(name, element = isBrowser() ? document.body : null) {
    if (!isBrowser() || !element) {
        return '';
    }
    const nameCap = name.charAt(0).toUpperCase() + name.slice(1);
    const props = [name, `webkit${nameCap}`, `Moz${nameCap}`, `O${nameCap}`, `ms${nameCap}`];
    for (const prop of props) {
        if (typeof element.style[prop] !== 'undefined') {
            return prop;
        }
    }
    return '';
}
export const supportAsyncStorage = (() => {
    if (!isBrowser() && !isServiceWorker()) {
        return false;
    }
    if (isServiceWorker()) {
        return true;
    }
    if (!isBrowser())
        return false;
    const windowAny = window;
    return (!!windowAny.openDatabase ||
        !!windowAny.indexedDB ||
        !!windowAny.webkitIndexedDB ||
        !!windowAny.mozIndexedDB ||
        !!windowAny.msIndexedDB);
})();
export const transformProperty = currentStyleProperty('transform');
export const transitionProperty = currentStyleProperty('transition');
export const transitionEndEvent = (() => {
    if (!isBrowser()) {
        return 'transitionend';
    }
    const el = document.createElement('div');
    const transitions = {
        transition: 'transitionend',
        OTransition: 'oTransitionEnd',
        MozTransition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
    };
    for (const t in transitions) {
        if (typeof el.style[t] !== 'undefined') {
            return transitions[t];
        }
    }
    return 'transitionend'; // Fallback
})();
